import { OverlayTrigger, Tooltip } from "react-bootstrap";

const ArchiveHint = () => (
  <OverlayTrigger
    placement="top"
    overlay={
      <Tooltip>
        El archivo está comprimido en formato <strong>.7z</strong> y protegido con
        contraseña. Para abrirlo necesitas <strong>7-Zip</strong> o{" "}
        <strong>WinRAR</strong> en Windows/Linux, o <strong>Keka</strong> en macOS.
      </Tooltip>
    }
  >
    <i
      className="bi bi-file-earmark-zip ms-1 text-muted"
      role="button"
      tabIndex={0}
      style={{ cursor: "help" }}
      aria-label="Requiere 7-Zip, WinRAR o Keka para abrir el archivo .7z"
    />
  </OverlayTrigger>
);

export default ArchiveHint;
